import AppConfigService from '../services/AppConfig';
import { City } from '../interfaces/AddressForm';

export const setBorder = (name: any) => {
  switch (name) {
    case 'contractType':
    case 'only':
    case 'offer':
    case 'iban':
      return '6px 6px 6px 6px';
    case 'product':
    case 'firstName':
      return '6px 6px 0 0';
    case 'amount':
    case 'nationality':
    case 'monthlyIncome':
    case 'province':
      return '0 0 6px 6px';
    case 'numberData':
    case 'birthdate':
      return '0 0 0 6px';
    case 'country':
    case 'termNumber':
      return '0 0 6px 0';
    case 'address':
      return '0 6px 0 0';
    case 'roadType':
      return '6px 0 0 0';
    case 'postalCode':
    default:
      return '0';
  }
};

export const setBorderWithCondition = (
  name: any,
  position?: any,
  identifier?: any,
  error?: any
) => {
  if (identifier) {
    switch (name) {
      case 'nationality':
        return '0 0 6px 6px';
      case 'birthdate':
      case 'country':
        return '0';
    }
  } else if (position === 'upper' && name === 'contractType') {
    return '6px 6px 0 0';
  } else if (name === 'auxiliaryData') {
    return position === 'right' ? '0 0 6px 0' : '0 0 6px 6px';
  } else if (name === 'postalCode') {
    return position === 'left' ? '0 0 0 6px' : '0';
  } else if (name === 'amount') {
    if (error === 'true') {
      return '0 0 6px 6px';
    } else {
      return position === 'left' ? '0 0 0 6px' : '0 0 6px 6px';
    }
  }
};

export const setBorderWithConditionMobile = (
  name: any,
  identifier?: any,
  position?: any
) => {
  if (identifier) {
    switch (name) {
      case 'nationality':
        return '0 0 6px 6px';
      case 'birthdate':
      case 'country':
        return '0';
    }
  } else if (position === 'upper' && name === 'contractType') {
    return '6px 6px 0 0';
  } else if (name === 'amount' && position === 'left') {
    return '0';
  }
};

export const setMobileBorder = (name: any) => {
  switch (name) {
    case 'contractType':
      return '6px';
    case 'product':
    case 'roadType':
    case 'firstName':
      return '6px 6px 0 0';
    case 'amount':
    case 'country':
    case 'auxiliaryData':
    case 'monthlyIncome':
    case 'province':
    case 'termNumber':
      return '0 0 6px 6px';
    case 'numberData':
      return '0 0 0 6px';
    default:
      return '0';
  }
};

export const blockCharacters = (event: any) => {
  return ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
};

export const blockCharactersNoDecimal = (event: any) => {
  return (
    ['e', 'E', '+', '-', '.', ','].includes(event.key) && event.preventDefault()
  );
};

export const transformAmount = (amount: any) => {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseFloat(amount));
};

export const checkPostalCode = async (postalCode: string) => {
  if (postalCode.length === 5) {
    try {
      const cities = await AppConfigService.getCity(postalCode);
      if (cities.length < 1) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
};

export const getCity = async (postalCode: string): Promise<City[]> => {
  try {
    const cities = await AppConfigService.getCity(postalCode);
    if (cities.length > 0) {
      return cities;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
